/**
 * PDP color swatch AJAX handler
 * Handles clicking color swatches to load different products without page reload.
 */

 // Re-executes inline scripts within an element.
function executeScripts(element) {
  element.querySelectorAll('script:not([src])').forEach((oldScript) => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

document.addEventListener('click', async function(e) {
  const swatch = e.target.closest('.color-swatch-link');
  if (!swatch) return;
  
  // Skip if this swatch is already selected
  if (swatch.classList.contains('color-swatch-current')) return;
  
  // Skip AJAX navigation if inside Quick Add modal - navigate to product page instead
  const quickAddModal = swatch.closest('quick-add-modal');
  if (quickAddModal) {
    const url = swatch.dataset.url;
    if (url) window.location.href = url;
    return;
  }
  
  const url = swatch.dataset.url;
  if (!url) return;
  
  // Find the main product section
  const currentSection = document.querySelector('section[id^="MainProduct-"]') 
    
  if (!currentSection) {
    window.location.href = url;
    return;
  }
  
  // Show loading state
  currentSection.style.opacity = '0.5';
  currentSection.style.pointerEvents = 'none';
  
  try {
    // Fetch the full product page (not section rendering)
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');
    
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    const newSection = doc.querySelector('section[id^="MainProduct-"]');
    
    if (!newSection) {
      window.location.href = url;
      return;
    }
    
    // Replace section
    currentSection.replaceWith(newSection);
    
    // Update URL without page reload
    history.replaceState({}, '', url);
    
    // Re-execute inline scripts (for Complete the Look slider, Tabby, size chart, etc.)
    executeScripts(newSection);
    
    // Reinitialize Shopify payment buttons
    window.Shopify?.PaymentButton?.init();
    
  } catch (error) {
    console.error('Color swatch AJAX error:', error);
    window.location.href = url;
  }
});